<div *ngIf="isLoading | async" class="overlay">
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.1)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
</div>
  